"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _getDistanceScrolled = _interopRequireDefault(require("@berlitz/max-utils/lib/getDistanceScrolled"));
var _MobileNav = _interopRequireDefault(require("./components/mobile/MobileNav"));
var _DesktopNav = _interopRequireDefault(require("./components/desktop/DesktopNav"));
var _styledComponents = require("styled-components");
var _lodash = _interopRequireDefault(require("lodash.throttle"));
var _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var MobileNavOffset = (0, _styledComponents.createGlobalStyle)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  body {\n    margin-top: ", ";\n    @media (min-width: ", ") {\n      margin-top: 0;\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.topNav.mobile.barHeight;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.md;
});
var TopNav = /*#__PURE__*/function (_Component) {
  _inherits(TopNav, _Component);
  var _super = _createSuper(TopNav);
  function TopNav(props) {
    var _this;
    _classCallCheck(this, TopNav);
    _this = _super.call(this, props);
    _this.state = {
      stickyNavActive: false,
      activeDropDown: null,
      bodyHasMargin: false
    };
    _this.handleDropDownFocus = function (focusedDropDownKey) {
      _this.setState({
        activeDropDown: focusedDropDownKey
      });
    };
    _this.closeDropDown = function () {
      if (!_this.state.activeDropDown) return;
      _this.setState({
        activeDropDown: null
      });
    };
    _this.ariaHideStickyNav = function (hide) {
      Array.apply(void 0, _toConsumableArray(document.querySelectorAll(".desktop-sticky-nav a,\n          .desktop-sticky-nav button,\n          .desktop-sticky-nav input,\n          .desktop-sticky-nav textarea"))).forEach(function (el) {
        return el.style.display = hide ? 'none' : 'inherit';
      });
    };
    _this.componentDidMount = function () {
      if (_this.isSticky) {
        window.addEventListener('scroll', _this.scrollListener);
        _this.ariaHideStickyNav(true);
      }
    };
    _this.componentWillUnmount = function () {
      if (_this.isSticky) window.removeEventListener('scroll', _this.scrollListener);
    };
    _this.handleScroll = function () {
      var windowOffset = (0, _getDistanceScrolled.default)();
      if (
      // We have scrolled below the threshold, activate the sticky nav
      windowOffset >= _this.props.stickyScrollThreshold && !_this.state.stickyNavActive) {
        _this.setState({
          stickyNavActive: true
        }, function () {
          return _this.ariaHideStickyNav(false);
        });
      } else if (
      // We have scrolled above the threshold, remove sticky nav
      windowOffset < _this.props.stickyScrollThreshold && _this.state.stickyNavActive) {
        _this.setState({
          stickyNavActive: false
        }, function () {
          return _this.ariaHideStickyNav(true);
        });
      }
    };
    _this.scrollListener = (0, _lodash.default)(function () {
      return _this.handleScroll();
    }, 500);
    _this.isSticky = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && _this.props.sticky;
    return _this;
  }
  _createClass(TopNav, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(MobileNavOffset, null), /*#__PURE__*/_react.default.createElement(_DesktopNav.default, _extends({}, this.props, {
        activeDropDown: this.state.activeDropDown,
        closeDropDown: this.closeDropDown,
        handleDropDownFocus: this.handleDropDownFocus,
        stickyNavActive: this.state.stickyNavActive,
        moreText: this.props.moreText
      })), this.props.sticky && /*#__PURE__*/_react.default.createElement(_DesktopNav.default, _extends({}, this.props, {
        activeDropDown: this.state.activeDropDown,
        closeDropDown: this.closeDropDown,
        handleDropDownFocus: this.handleDropDownFocus,
        stickyNavActive: this.state.stickyNavActive,
        telNumber: this.props.telNumber,
        moreText: this.props.moreText,
        isSticky: true
      })), /*#__PURE__*/_react.default.createElement(_MobileNav.default, _extends({}, this.props, {
        telNumber: this.props.telNumber
      })));
    }
  }]);
  return TopNav;
}(_react.Component);
TopNav.defaultProps = {
  isDark: false,
  stickyScrollThreshold: 600,
  priorityNumber: 4,
  moreText: 'More'
};
var _default = TopNav;
exports.default = _default;